import React, { Fragment, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
// === CRITICAL RESOURCES — injected as single fragment to avoid reflows ===
const fragment = document.createDocumentFragment();
// Preconnect to image CDN
const pc = document.createElement('link');
pc.rel = 'preconnect';
pc.href = 'https://cdn.magicpatterns.com';
fragment.appendChild(pc);
// Preload hero image (LCP element)
const preload = document.createElement('link');
preload.rel = 'preload';
preload.as = 'image';
preload.setAttribute('imagesizes', '(max-width: 768px) 100vw, 768px');
preload.href = 'https://cdn.magicpatterns.com/uploads/87dYyEWwxvxDSawQQfbd23/WhatsApp_Image_2026-03-23_at_23.51.54.jpg';
fragment.appendChild(preload);
// Non-blocking Google Fonts
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;700;800&display=swap';
fontLink.media = 'print';
fontLink.onload = function () {
  fontLink.media = 'all';
};
fragment.appendChild(fontLink);
// Single DOM write
document.head.appendChild(fragment);
// === META PIXEL — Load immediately, only once ===
if (!(window as any)._mpPixelLoaded) {
  ;
  (window as any)._mpPixelLoaded = true;
  !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  (window as any).fbq('init', '1413771729918296');
  (window as any).fbq('track', 'PageView');
}
export function App() {
  return <LandingPage data-id="element-0" />;
}